import { AttachmentHTMLAttributes } from 'react';
import Asset from '@/components/asset';

export default function Attachment(props: AttachmentHTMLAttributes<HTMLAttachmentElement>) {
    return <Asset element={'t-attachment'} {...props} />;
}


